/**
 * Client-side helpers for the refundable security deposit.
 */

export const TRANSITION_SYSTEM_AUTO_REFUND_DEPOSIT = 'transition/system-auto-refund-deposit';
export const TRANSITION_OPERATOR_RETAIN_DEPOSIT = 'transition/operator-retain-deposit';
export const TRANSITION_OPERATOR_PARTIAL_REFUND_DEPOSIT =
  'transition/operator-partial-refund-deposit';

export const DEPOSIT_TRANSITIONS = {
  [TRANSITION_SYSTEM_AUTO_REFUND_DEPOSIT]: 'refunded',
  [TRANSITION_OPERATOR_RETAIN_DEPOSIT]: 'retained',
  [TRANSITION_OPERATOR_PARTIAL_REFUND_DEPOSIT]: 'partially-refunded',
};

export const DEPOSIT_TRANSITION_NAMES = Object.keys(DEPOSIT_TRANSITIONS);

/**
 * Resolve deposit status from transaction transitions, falling back to protectedData.
 *
 * @param {Object} transaction
 * @returns {'pending'|'refunded'|'retained'|'partially-refunded'|null}
 */
export const getDepositStatus = transaction => {
  const transitions = transaction?.attributes?.transitions || [];
  for (let i = transitions.length - 1; i >= 0; i -= 1) {
    const status = DEPOSIT_TRANSITIONS[transitions[i]?.transition];
    if (status) {
      return status;
    }
  }
  const protectedStatus = transaction?.attributes?.protectedData?.depositStatus;
  if (protectedStatus) {
    return protectedStatus;
  }
  const amount = transaction?.attributes?.protectedData?.depositAmountInSubunits;
  return Number.isInteger(amount) && amount > 0 ? 'pending' : null;
};

/**
 * Whether the last meaningful (non-deposit) process state is a completed rental.
 *
 * @param {Function} isCompleted - process.isCompleted
 * @param {Object} transaction
 * @returns {boolean}
 */
export const isDepositWindowOpen = (isCompleted, transaction) => {
  const status = getDepositStatus(transaction);
  if (status !== 'pending') {
    return false;
  }
  const lastMeaningful = [...(transaction?.attributes?.transitions || [])]
    .reverse()
    .find(t => !DEPOSIT_TRANSITION_NAMES.includes(t.transition));
  return lastMeaningful ? isCompleted(lastMeaningful.transition) : false;
};
